import {
  DATE_YYYYMMDD,
  ELECTRIC_SUMMARY_FILTER_TYPE,
  formatDate,
  formatDateNull,
  INTERNET_SUMMARY_FILTER_TYPE,
  MOBILE_SUMMARY_FILTER_TYPE,
} from '../../../Common';

export const getTimeValue = (dt: Date | null): string => {
  if (dt) return formatDateNull(dt.toLocaleString(), 'YYYY/MM/DD HH:mm:ss', 'YYYYMMDD');
  return '';
};

export const getDurationFromValue = (timeValueFrom: string): string => {
  if (!timeValueFrom || timeValueFrom <= DATE_YYYYMMDD.MIN) return '';
  return formatDate(timeValueFrom, 'YYYYMMDD', 'YYYY/MM/DD');
};

export const getDurationToValue = (timeValueTo: string): string => {
  if (!timeValueTo || timeValueTo >= DATE_YYYYMMDD.MAX) return '';
  return formatDate(timeValueTo, 'YYYYMMDD', 'YYYY/MM/DD');
};

export const getErrorMessage = (timeValueFrom: string, timeValueTo: string): string[] => {
  if (!timeValueFrom || !timeValueTo || timeValueTo >= timeValueFrom) return [];
  const errorMessage: string[] = [];
  errorMessage.push('利用可能期間を正しく入力してください。');
  return errorMessage;
};

export const isCheckedAllCheckbox = (
  listCheckedMobile: string[],
  listCheckedInternet: string[],
  listCheckedElectric: string[],
): boolean => {
  return (
    listCheckedMobile.length === Object.keys(MOBILE_SUMMARY_FILTER_TYPE).length &&
    listCheckedInternet.length === Object.keys(INTERNET_SUMMARY_FILTER_TYPE).length &&
    listCheckedElectric.length === Object.keys(ELECTRIC_SUMMARY_FILTER_TYPE).length
  );
};
